module.exports = require("react-dev-utils/ForkTsCheckerWarningWebpackPlugin.js");